import { FocusEvent, useCallback, useRef } from "react";

declare global {
  interface Window {
    wmrk?: {
      Utils?: {
        addSkipMenu?: (event: Event) => void;
      };
    };
  }
}

declare const wmrk: {
  gotoMain?: () => void;
  gotoNav?: () => void;
};

interface SkipMenuProps {
  showNavigation?: boolean;
}

const handleSkipToMain = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  wmrk?.gotoMain?.();
};

const handleSkipToNav = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  wmrk?.gotoNav?.();
};

export default function SkipMenu({ showNavigation = true }: SkipMenuProps): JSX.Element {
  if (!showNavigation) {
    return (
      <section
        id="skip-to-menu"
        aria-label="Skip to main content"
      >
        <a
          className="skip-to"
          href="#maincontent"
          accessKey="0"
          onClick={handleSkipToMain}
        >
          Skip to Main Content
        </a>
      </section>
    );
  }

  return <SkipMenuWithDropdown />;
}

function SkipMenuWithDropdown(): JSX.Element {
  const initializedRef = useRef(false);

  const initializeMenu = useCallback(
    (event: FocusEvent<HTMLAnchorElement>) => {
      if (initializedRef.current) {
        return;
      }

      const addSkipMenu = window?.wmrk?.Utils?.addSkipMenu;
      if (addSkipMenu) {
        addSkipMenu(event.nativeEvent);
        initializedRef.current = true;
      }
    },
    []
  );

  return (
    <section
      id="skip-to-menu"
      aria-label="Skip navigation shortcuts"
    >
      <a
        className="skip-to"
        href="#skip-menu-options"
        accessKey="0"
        role="button"
        aria-expanded="false"
        aria-controls="skip-menu-options"
        onFocus={initializeMenu}
      >
        Skip to ...
      </a>

      <ul id="skip-menu-options" aria-label="Skip navigation destinations">
        <li>
          <a
            className="skiplink"
            tabIndex={-1}
            href="#maincontent"
            onClick={handleSkipToMain}
            id="skip-1"
          >
            Main Content
          </a>
        </li>
        <li>
          <a
            className="skiplink"
            tabIndex={-1}
            href="#navmenu"
            onClick={handleSkipToNav}
            id="skip-2"
          >
            Navigation
          </a>
        </li>
      </ul>
    </section>
  );
}

